<template>
  <v-dialog
    v-model="isOpened"
    persistent
    scrollable
    width="600px"
  >
    <v-form @submit.prevent.native="$canWrite && (submit($event))">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar color="primary darken-1" dark>
            <v-toolbar-title>{{ this.title }}</v-toolbar-title>
            <v-spacer />
            <v-btn text icon color="white" @click="closeDialog">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text class="pa-3 pb-0">
          <v-container class="pa-2">
            <v-alert
              :value="true"
              type="error"
              class="mb-4"
              v-if="this.isEmptyName"
            >
              Veuillez remplir le champ "Nom".
            </v-alert>
            <v-text-field
              v-model="name"
              label="Nom"
              hide-details
              outlined
              required
              autofocus
              color="primary darken-1"/>
            <v-row class="pa-2">
              <v-col cols="12" md="6" class="pa-3 pb-0" align-self="center">
                <v-checkbox
                  class="mt-0 mb-2 subtitle-1"
                  v-model="isFinished"
                  label="Provoque la clôture de l'intervention"
                  hide-details
                  required
                  color="primary darken-1" />
              </v-col>
              <v-col cols="12" md="6" class="pa-3 pb-0" align-self="center" align="center">
                <v-btn v-if="isMenuOpened" @click="isMenuOpened = false" color="primary darken-1">Choisir</v-btn>
                <span class="pr-8 black--text subtitle-1" v-if="!isMenuOpened">Couleur :</span>
                <v-menu v-model="isMenuOpened" :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :color="color"
                      v-on="on"
                    >
                    </v-btn>
                  </template>
                  <v-color-picker
                    v-model="color"
                    hide-inputs
                  ></v-color-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">Annuler</v-btn>
          <v-btn
            :disabled="!$canWrite"
            color="primary darken-1"
            @click="$canWrite && (submit($event))"
            :loading="isSaving"
          >
            {{ this.isUpdating ? `Modifier` : `Ajouter` }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  name: `SaveStatus`,
  props: {
    value: Boolean,
    status: {
      type: Object,
      required: false,
    },
    maker: Object,
  },
  data: () => ({
    color: `#ff0000`,
    isMenuOpened: false,
    isFinished: false,
    name: ``,
    isSaving: false,
    isEmptyName: false,
  }),
  computed: {
    isOpened: {
      get() { return this.value; },
      set(value) { this.$emit(`input`, value); },
    },
    isUpdating() {
      return this.status && this.status.id;
    },
    title() {
      return this.isUpdating ? `Modifier un statut` : `Ajouter un statut`;
    },
  },
  methods: {
    initLocalState() {
      if (this.isUpdating) {
        this.color = this.status.color;
        this.name = this.status.name;
        this.isFinished = this.status.isFinished;
      } else {
        this.color = `#ff0000`;
        this.isFinished = false;
        this.name = ``;
      }
      this.isMenuOpened = false;
      this.isSaving = false;
      this.isEmptyName = false;
    },
    async submit() {
      this.isSaving = true;
      if (this.name.length === 0) {
        this.isEmptyName = true;
        this.isSaving = false;
      } else {
        await this.$store.dispatch(this.isUpdating ? `model/status/saveStatus` : `model/status/addStatus`, {
          id: this.isUpdating ? this.status.id : ``,
          name: this.name,
          color: this.color,
          isFinished: this.isFinished,
          isLast: this.isUpdating ? this.status.isLast : ``,
          makerId: this.maker?.id,
        });
        this.isSaving = false;
        this.isOpened = false;
        this.$emit(`save`);
      }
    },
    closeDialog() {
      this.isOpened = false;
      this.$emit(`close`);
    },
  },
  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.initLocalState();
      }
    },
  },
};
</script>
